import { Checkbox as MuiCheckbox } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import clsx from 'clsx';
import {
  Controller,
  ControllerProps,
  useController,
  useFormContext,
} from 'react-hook-form';

export interface CheckboxProps extends Omit<ControllerProps, 'render'> {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkedIcon?: any;
  labelClassName?: string;
  disabled?: boolean;
  title?: string;
}

export const Checkbox = ({
  label,
  icon,
  checkedIcon,
  labelClassName,
  disabled,
  title,
  ...props
}: CheckboxProps): JSX.Element => {
  const { control } = useFormContext();
  const {
    fieldState: { error },
  } = useController({ name: props.name, control });

  return (
    <FormControlLabel
      className={clsx(labelClassName, { 'text-mui-error': error })}
      label={label}
      control={
        <Controller
          {...props}
          render={({ field }) => (
            <MuiCheckbox
              {...field}
              className={clsx({ 'text-mui-error': error })}
              title={title}
              icon={icon}
              disabled={disabled}
              checkedIcon={checkedIcon}
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
            />
          )}
        />
      }
    />
  );
};
